import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Universal back button. Uses browser history when possible, falls back to a
 * sensible default route based on where the user is. Sticky, keyboard-friendly,
 * accessible.
 */
export default function BackButton({ fallback, label = "Back", className = "" }) {
  const navigate = useNavigate();
  const location = useLocation();

  function goBack() {
    // If we have history to pop, prefer it — otherwise route to fallback / smart default.
    if (window.history.length > 1 && document.referrer) {
      navigate(-1);
      return;
    }
    const smart = fallback || pickFallback(location.pathname);
    navigate(smart);
  }

  return (
    <button
      type="button"
      onClick={goBack}
      className={
        "inline-flex items-center gap-2 px-3 py-2 border border-border bg-background/60 backdrop-blur " +
        "overline text-xs hover:bg-foreground hover:text-background transition " +
        className
      }
      aria-label="Go back to previous page"
      data-testid="back-button"
    >
      <ArrowLeft className="w-4 h-4" />
      <span>{label}</span>
    </button>
  );
}

function pickFallback(pathname) {
  if (pathname.startsWith("/admin")) return "/dashboard";
  if (pathname.startsWith("/workspace")) return "/dashboard";
  if (pathname.startsWith("/history")) return "/dashboard";
  if (pathname.startsWith("/billing")) return "/dashboard";
  if (pathname.startsWith("/account")) return "/dashboard";
  if (pathname.startsWith("/dashboard")) return "/";
  if (pathname.startsWith("/blog/")) return "/blog";
  return "/";
}
